import { Box, Grid, Typography } from '@material-ui/core'
import { Datagrid, List, TextField } from 'react-admin'

import { hasPermission, Permissions } from '../../Permissions'
import AddStaffUser from './AddStaffUser'

const PermissionGroupList = (props: any) => {
  const canCreateStaffUser =
    props.permissions && hasPermission(props.permissions, Permissions.CreateStaffUser)
  return (
    <>
      <Box mt={1} />
      <Grid container justifyContent="space-between">
        <Grid item>
          <Typography variant="body1">Groups</Typography>
        </Grid>
        {canCreateStaffUser && (
          <Grid item>
            <AddStaffUser {...props} />
          </Grid>
        )}
      </Grid>
      <Box mt={2} />
      <List
        {...props}
        exporter={false}
        bulkActionButtons={false}
        pagination={false}
        filters={false}
        actions={false}
        sort={false}
      >
        <Datagrid rowClick="show" size="medium" header={<></>} optimized>
          <TextField source="name" />
        </Datagrid>
      </List>
    </>
  )
}

export default PermissionGroupList
